module.exports = __webpack_public_path__ + "img/search.3ac92f66.svg";